import { render, staticRenderFns } from "./from.vue?vue&type=template&id=361b699a&scoped=true&"
import script from "./from.vue?vue&type=script&lang=js&"
export * from "./from.vue?vue&type=script&lang=js&"
import style0 from "./from.vue?vue&type=style&index=0&id=361b699a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361b699a",
  null
  
)

export default component.exports